export default __webpack_public_path__ + "images/38b7ff433eaa0e67b6b84d57447c7a56.png";